

declare let gtag: Function;




export class GoogleAnalyticsService {

  public  eventEmitter(eventName: string, eventCategory: string, eventLabel: string = '', eventValue: number = 0) {
    gtag('event', eventName, {
      'event_category': eventCategory,
      'event_label': eventLabel,
      'value': eventValue
    })
  }
  
  
}

